interface TablePaginationProps {
  page: number;
  pageSize: number;
  totalItems: number;
  pageSizeOptions?: number[];
  onPageChange: (page: number) => void;
  onPageSizeChange?: (size: number) => void;
}

export function TablePagination({
  page,
  pageSize,
  totalItems,
  pageSizeOptions = [25, 50, 100],
  onPageChange,
  onPageSizeChange,
}: TablePaginationProps) {
  if (totalItems === 0) return null;

  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const safePage = Math.min(page, totalPages);
  const from = (safePage - 1) * pageSize + 1;
  const to = Math.min(safePage * pageSize, totalItems);

  return (
    <div className="ph-table-pagination">
      <span className="ph-table-pagination-range">
        {from}–{to} sur {totalItems}
      </span>
      <div className="d-flex align-items-center gap-2 flex-wrap">
        {onPageSizeChange && (
          <label className="ph-table-pagination-size mb-0">
            <span className="me-1">Par page</span>
            <select
              className="form-select form-select-sm"
              value={pageSize}
              onChange={(e) => onPageSizeChange(Number(e.target.value))}
              aria-label="Nombre de lignes par page"
            >
              {pageSizeOptions.map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </label>
        )}
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          disabled={safePage <= 1}
          onClick={() => onPageChange(safePage - 1)}
        >
          Précédent
        </button>
        <span className="small text-muted">
          Page {safePage} / {totalPages}
        </span>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          disabled={safePage >= totalPages}
          onClick={() => onPageChange(safePage + 1)}
        >
          Suivant
        </button>
      </div>
    </div>
  );
}
